<template>
  <div
    v-if="isValidType"
    class="news-hub-type"
    :class="{ 'news-hub-type--floating': floating }"
    :style="{ color: typeColor }">
    <font-awesome-icon :icon="icon"
                       class="icon"
                       aria-hidden="true">
    </font-awesome-icon>
    {{ label }}
  </div>
</template>

<script>
export default {
  name: "NewsHubType",
  props: {
    type: {
      type: String,
      required: true,
    },
    floating: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      types: [
        {
          key: "blogItem",
          label: "Blog",
          icon: ["fal", "comment-alt-dots"],
          color: "#333",
        },
        {
          key: "pressArticle",
          label: "Press Article",
          icon: ["far", "megaphone"],
          color: "#333",
        },
        {
          key: "pressRelease",
          label: "Press Release",
          icon: ["far", "megaphone"],
          color: "#333",
        },
        {
          key: "report",
          label: "Report",
          icon: ["fal", "clipboard-list"],
          color: "#333",
        },
        {
          key: "webinarItem",
          label: "Webinar",
          icon: ["fal", "tv"],
          color: "#333",
        },
        {
          key: "caseStudyItem",
          label: "Case Study",
          icon: ["fal", "file-search"],
          color: "#333",
        },
        {
          key: "podcasts",
          label: "Podcast",
          icon: ["fal", "microphone-alt"],
          color: "#333",
        },
      ],
    };
  },
  computed: {
    isValidType () {
      return this.types.some( t => t.key === this.type );
    },
    selectedType () {
      return this.types.find( t => t.key === this.type );
    },
    label () {
      return this.selectedType.label;
    },
    icon () {
      return this.selectedType.icon;
    },
    typeColor () {
      return this.selectedType.color;
    },
  },
};
</script>

<style lang="less" scoped>
.news-hub-type {
  font-size: 0.75rem;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: #fff;
  border-radius: 5px;
  padding: 6px 18px;
  margin-bottom: 10px;
  align-self: flex-start;
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;

  .icon {
    margin-right: 5px;
  }

  &--floating {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  &:hover {
    opacity: 1;
  }
}
</style>
